<template>
  <y-shelf title="我的钱包">
    <span slot="right"></span>
    <div slot="content">
      <div class="deposit-main">
        <div class="deposit-left">
          <span class="l-span">我的余额：</span><span class="c-span"><span class="c-text">{{user.balance}} </span>元</span>
        </div>
        <div class="deposit-right">
          <!-- <el-button v-if="user.userType == '20'" @click="dialogVisible = true">提现</el-button> -->
          <!-- <el-button v-else type="primary" @click="rechargeDialogVisible = true">充值</el-button> -->
          <el-button v-if="user.userType == '20'" @click="dialogVisible = true">提现</el-button>
          <el-button v-else type="primary" @click="rechargeDialogVisible = true">充值</el-button>
        </div>
        <div style="padding-top: 10px;">
          <el-link v-if="user.userType == '20'" style="padding-right: 15px; " type="primary"
            @click="drawal">提现记录</el-link>
          <el-link v-else style="padding-right: 15px; " type="primary" @click="rech">充值记录</el-link>
          <el-link type="primary" @click="access">收支明细</el-link>
        </div>
      </div>
      <!-- 提现弹窗 -->
      <el-dialog title="申请提现" :visible.sync="dialogVisible" width="40%" center>
        <el-form ref="withdrawForm" :model="withdrawForm" label-width="100px" style="margin-left: 13%;">
          <el-form-item label="提现方式：">
            <el-select v-model="withdrawForm.type" placeholder="请选择提现方式">
              <!-- <el-option label="微信" value="00"></el-option> -->
              <el-option label="支付宝" value="01"></el-option>
              <el-option label="银行卡" value="02"></el-option>
            </el-select>
            <span class="account_blance" style="margin-left: 3%;" v-if="withdrawForm.type == '02'"><span>每次最高提现</span><b
                class="balance_money">10000</b> <span>元</span>，当天可提现三次</span>
          </el-form-item>
          <el-form-item label="开户行名称：" v-if="withdrawForm.type == '02'">
            <el-select v-model="withdrawForm.bankName">
              <el-option style="display: block;" v-for="(item, index) in optionsList" :key="index" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开户分支行：" v-if="withdrawForm.type == '02'">
            <el-input type="text" style="width: 50%;" placeholder="请输入开户分支行名称" v-model="withdrawForm.branchName"
              :value="withdrawForm.branchName"></el-input>
          </el-form-item>
          <el-form-item :label="withdrawForm.type == '01'? '姓名：':'开户人姓名：'">
            <el-input type="text" style="width: 50%;" placeholder="请输入姓名" v-model="withdrawForm.accName"
              :value="withdrawForm.accName"></el-input>
          </el-form-item>
          <!-- <el-form-item label="手机号：" v-if="withdrawForm.type == '01'" >
		    <el-input
		         type="text"
		         style="width: 50%;"
		         placeholder="请输入手机号"
		         v-model="withdrawForm.phone"
		         :value="withdrawForm.phone"
		     ></el-input>
		  </el-form-item> -->
          <el-form-item :label="withdrawForm.type == '01'?'支付宝账号：':'银行卡号：'">
            <!--            <el-input
                 type="text"
                 style="width: 50%;"
                 placeholder="请输入银行卡卡号"
                 onkeyup="this.value=this.value.replace(/\D/g,'')"
                 v-model="withdrawForm.accCode"
                 :value="withdrawForm.accCode"
                auto-complete="off"
             ></el-input> -->
            <el-autocomplete class="inline-input" style="width: 50%;" v-model="withdrawForm.accCode"
              :fetch-suggestions="querySearch" :placeholder="withdrawForm.type == '01'?'请输入支付宝账号':'请输入银行卡卡号'"
              @select="handleSelect"></el-autocomplete>
          </el-form-item>
          <el-form-item label="提现金额：">
            <el-input v-model="withdrawForm.subAmount" type="text"
              onkeyup="this.value=this.value.replace(/[^\d.]/g, '')"
              onafterpaste="this.value=this.value.replace(/[^\d.]/g, '')" clearable style="width: 50%;"> <template
                slot="append">元</template></el-input>
            <span class="account_blance" style="margin-left: 3%;"><span>可提现金额：</span>
              <b class="balance_money" v-if="user.balance>=30000">30000</b>
              <b class="balance_money" v-else>{{user.balance}}</b>
              <span>元</span>
            </span>
          </el-form-item>
          <el-form-item label="提现手续费：" v-if="user.userType == '10'">
            <span>{{parseMoney( withdrawForm.subAmount*0.4 )}} 元</span> <span class="account_blance"><span>手续费：</span>
              <b class="balance_money">40%</b></span>
          </el-form-item>
          <el-form-item label="实际到账：">
            <span class="c-span">
              <span v-if="user.userType != '10'" class="c-text">{{parseMoney( withdrawForm.subAmount )}}元</span>
              <span v-else class="c-text">{{parseMoney( withdrawForm.subAmount*0.6 )}} 元</span>
            </span>
          </el-form-item>
          <p class="prompt" v-if="withdrawForm.type == '02'" :style="user.userType == '10'?'top:21%;':'top:23%;'">
            注意：每次最低提现金额<b class="balance_money">200</b>元</p>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="onSubmitWithdraw('withdrawForm')">申请提现</el-button>
          <div style="height: 30px;"></div>
        </span>
      </el-dialog>
      <!-- 充值弹窗 -->
      <el-dialog title="充值中心" :visible.sync="rechargeDialogVisible" width="40%" center>
        <el-form ref="rechargeForm" :model="rechargeForm">
          <div style="margin-left:25%;">
            <el-form-item label="充值金额：" v-if="rechargeForm.style !== '00'">
              <el-input v-model="rechargeForm.money" type="text" onkeyup="this.value=this.value.replace(/\D/g,'')"
                onafterpaste="this.value=this.value.replace(/\D/g,'')" clearable style="width: 50%;"> <template
                  slot="append">元</template></el-input>
            </el-form-item>
            <el-form-item label="充值方式：" prop="resource">
              <el-radio-group v-model="rechargeForm.style">
                <el-radio label="00">充值卡</el-radio>
                <el-radio label="01">支付宝支付</el-radio>
                <!-- <el-radio label="02">微信支付</el-radio> -->
              </el-radio-group>
            </el-form-item>
            <el-form-item label="卡号：" style="letter-spacing: 14px;" v-if="rechargeForm.style == '00'">
              <el-input type="text" style="width: 250px;margin-left: -13px;" v-model="rechargeForm.cardNo" clearable
              autocomplete="off" placeholder="请输入充值卡卡号"
              name="cardName"></el-input>
            </el-form-item>
            <el-form-item label="卡密：" style="letter-spacing: 14px;" v-if="rechargeForm.style == '00'">
              <el-input type="password" style="width: 250px;margin-left: -13px;" v-model="rechargeForm.cardKey" placeholder="请输入充值卡卡密"
                clearable autocomplete="new-password" name="cardPassword"></el-input>
            </el-form-item>

            <el-form-item label="付款方式：" v-if="rechargeForm.style !== '00'">
              <span>{{ rechargeForm.style == '01' ? "支付宝支付" : "微信支付" }}</span>
            </el-form-item>
            <el-form-item label="付款金额：" v-if="rechargeForm.style !== '00'">
              <span>¥ {{ parseMoney(rechargeForm.money) }}</span>
            </el-form-item>
          </div>
          <!-- <el-form-item label="付款信息：">
            <div class="pay-order-bank" v-if="rechargeForm.style=='00'" style="margin-left: -300px;">
              <el-form-item label="卡号：" style="margin-bottom: 2%;">
                <el-input type="text" style="width: 100%;" v-model="rechargeForm.cardNo" clearable
                  placeholder="请输入充值卡卡号"></el-input>
              </el-form-item>
              <el-form-item label="卡密：" style="margin-top: 2%;">
                <el-input type="password" style="width: 100%;" v-model="rechargeForm.cardKey" placeholder="请输入充值卡卡密"
                  clearable autocomplete="off"></el-input>
              </el-form-item>
            </div>
            <div class="pay-order-bank" v-else>
              <div class="pay-bank-item">
                <div class="pay-bank-label">
                  付款方式：
                </div>
                <div class="pay-bank-value">
                  {{rechargeForm.style=='01'?"支付宝支付":"微信支付"}}
                </div>
              </div>
              <div class="pay-bank-item">
                <div class="pay-bank-label">
                  付款金额：
                </div>
                <div class="pay-bank-value">
                  ¥ {{parseMoney(rechargeForm.money)}}
                </div>
              </div>
            </div>
          </el-form-item> -->
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="rechargeDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="onSubmitRecharge('rechargeForm')">充值</el-button>
          <div style="height: 30px;"></div>
        </span>
      </el-dialog>
      <!-- 提现记录和收支明细 -->
      <el-dialog :title="chongzhi == true?'充值记录':(tixian == true?'提现记录':'收支明细')" :visible.sync="open" width="60%"
        center>
        <el-table ref="multipleTable" :data="balanceList" tooltip-effect="dark" style="width: 100%;font-size: 13px;"
          size="small" :stripe="true" border v-if="balanceList.length > 0">
          <!-- 提现 -->
          <el-table-column prop="withdrawNo" label="流水号" width="250" align="center" show-overflow-tooltip v-if="tixian">
          </el-table-column>

          <el-table-column prop="type" label="提现方式" align="center" v-if="tixian">
            <template #default="scope">
              {{ scope.row.type == '00'?'微信':(scope.row.type == '01'?'支付宝':'银行卡') }}
            </template>
          </el-table-column>

          <el-table-column prop="subAmount" label="提现金额 " align="center" v-if="tixian">
            <template #default="scope">
              {{ scope.row.subAmount}}元
            </template>
          </el-table-column>

          <el-table-column prop="status" label="提现状态 " align="center" v-if="tixian">
            <template #default="scope">
              {{ scope.row.status == '0'?'未处理':(scope.row.status == '1'?'已处理':'已驳回') }}
            </template>
          </el-table-column>

          <el-table-column prop="remark" label="备注 " align="center" show-overflow-tooltip v-if="tixian">
          </el-table-column>

          <el-table-column prop="createTime" label="提现时间" align="center" v-if="tixian">
          </el-table-column>
          <!-- 收支明细 -->
          <el-table-column prop="referNo" label="关联服务单号" width="200" align="center" show-overflow-tooltip v-if="detail">
          </el-table-column>

          <el-table-column prop="flowType" label="交易类型" align="center" v-if="detail">
            <template #default="scope">
              {{scope.row.flowType == '0'?'支出':'收入'}}
            </template>
          </el-table-column>
          <el-table-column prop="flowAcc" label="变动金额" align="center" v-if="detail">
            <template #default="scope">
              {{scope.row.flowAcc}}元
            </template>
          </el-table-column>

          <el-table-column prop="flowBalAfter" label="变动后金额" align="center" v-if="detail">
            <template #default="scope">
              {{scope.row.flowBalAfter}}元
            </template>
          </el-table-column>

          <el-table-column prop="remark" label="备注" align="center" v-if="detail">
          </el-table-column>

          <el-table-column prop="createTime" label="记账时间" align="center" v-if="detail">
          </el-table-column>

          <!-- 充值 -->
          <el-table-column prop="createTime" label="记账时间" align="center" v-if="chongzhi">
          </el-table-column>
        </el-table>
        <div class="no-data" v-else>
          暂无数据
        </div>
        <div class="pagination-wrap" v-if="balanceList.length">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="queryParams.pageNum"
            :page-size="queryParams.pageSize" layout="total,prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </el-dialog>
    </div>
  </y-shelf>
</template>

<script>
  import YShelf from '/components/YShelf'
  import {
    mapState
  } from 'vuex'
  export default {
    data() {
      return {
        dialogVisible: false,
        rechargeDialogVisible: false,
        withdrawForm: {
          type: '01',
          bankName: '',
          branchName: '',
          subAmount: 0.00,
          accName: '',
          accCode: '',
          phone: ''
        },
        rechargeForm: {
          style: '00',
          money: 0.00,
          payBankNo: '',
          cardNo: '',
          cardKey: ''
        },
        optionsList: [{
            label: '工商银行',
            value: '工商银行'
          },
          {
            label: '建设银行',
            value: '建设银行'
          },
          {
            label: '交通银行',
            value: '交通银行'
          },
          {
            label: '农业银行',
            value: '农业银行'
          },
          {
            label: '邮政储蓄银行',
            value: '邮政储蓄银行'
          },
          {
            label: '中国银行',
            value: '中国银行'
          },
          {
            label: '渤海银行',
            value: '渤海银行'
          },
          {
            label: '光大银行',
            value: '光大银行'
          },
          {
            label: '广发银行',
            value: '广发银行'
          },
          {
            label: '中信银行',
            value: '中信银行'
          },
          {
            label: '恒丰银行',
            value: '恒丰银行'
          },
          {
            label: '华夏银行',
            value: '华夏银行'
          },
          {
            label: '民生银行',
            value: '民生银行'
          },
          {
            label: '浦发银行',
            value: '浦发银行'
          },
          {
            label: '深发展银行',
            value: '深发展银行'
          },
          {
            label: '兴业银行',
            value: '兴业银行'
          },
          {
            label: '招商银行',
            value: '招商银行'
          },
          {
            label: '浙商银行',
            value: '浙商银行'
          },
        ],
        restaurants: [],
        chongzhi: false,
        tixian: false,
        detail: false,
        open: false,
        balanceList: [],
        queryParams: {
          pageNum: 1,
          pageSize: 15,
        },
        total: 0,
      }
    },
    computed: {
      ...mapState(['user'])
    },
    methods: {
      loadDataList() {
        this.loading = true;
        if (this.tixian == true) {
          this.$api.post({
            url: '/user/withdrawList?pageNum=' + this.queryParams.pageNum + '&pageSize=' + this.queryParams.pageSize
          }).then(res => {
            this.noData = res.total > 0 ? false : true;
            this.balanceList = res.rows
            this.total = res.total
          })
        } else if (this.detail == true) {
          this.$api.post({
            url: '/user/userFlowList?pageNum=' + this.queryParams.pageNum + '&pageSize=' + this.queryParams
              .pageSize,
            data: this.queryParams
          }).then(res => {
            this.noData = res.total > 0 ? false : true;
            this.balanceList = res.rows;
            this.total = res.total
          })
        } else {
          // 充值
        }
      },
      onSubmitWithdraw(name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            let withdrawType = this.withdrawForm.type
            if(withdrawType=='02'&&this.withdrawForm.subAmount<200){
              this.$message({
                type:'error',
                message:'提现金额小于200元,请使用支付宝提现'
              })
              return false;
            }
            //验证通过
            let formData = new FormData();
            for (var key in this.withdrawForm) {
              formData.append(key, this.withdrawForm[key]);
            }
            var tempdata = {
              type: formData.get('type'),
              bankName: formData.get('bankName'),
              branchName: formData.get('branchName'),
              accName: formData.get('accName'),
              subAmount: formData.get('subAmount'),
              accCode: formData.get('accCode')
            }
            if (this.user.userType == '10') {
              tempdata.subAmount = tempdata.subAmount * 0.6;
            }
            this.$api.post({
              url: '/user/withdraw',
              data: tempdata
            }).then(res => {
              if (res.code == 200) {
                this.$yxz.msg('提现成功', 'success')
                this.rechargeDialogVisible = false
                this.$store.commit('user/setUserInfo', {
                  balance: parseFloat((this.user.balance - res.data).toFixed(2))
                });
              } else {
                this.$yxz.msg(res.msg);
              }
            })
            this.dialogVisible = false;
          } else {
            //验证失败
            return false;
          }
        })
        if (this.withdrawForm.accCode == "") {
          return false
        } else {
          this.restaurants = localStorage.history_input ? JSON.parse(localStorage.getItem('history_input')) : []
          let temp = this.restaurants.length
          if (temp == 0) {
            this.restaurants.push({
              'key': 0,
              'value': this.withdrawForm.accCode + ''
            })
            localStorage.setItem('history_input', JSON.stringify(this.restaurants))
          } else {
            this.restaurants.forEach((item, index) => {
              if (item.value.indexOf(this.withdrawForm.accCode) == -1) {
                for (var i = this.restaurants.length; i < temp + 1; i++) {
                  this.restaurants.push({
                    'key': i,
                    'value': this.withdrawForm.accCode + ''
                  })
                }
                localStorage.setItem('history_input', JSON.stringify(this.restaurants))
              }
            })
          }
        }
      },
      onSubmitRecharge(name) {
        if (this.rechargeForm.style == '00') {
          this.$refs[name].validate((valid) => {
            if (valid) {
              let formData = new FormData();
              for (var key in this.rechargeForm) {
                formData.append(key, this.rechargeForm[key]);
              }
              this.$api.post({
                url: '/card/recharge',
                data: {
                  cardNo: formData.get('cardNo'),
                  cardKey: formData.get('cardKey'),
                }
              }).then(res => {
                if (res.code == 200) {
                  this.$yxz.msg('充值成功', 'success')
                  this.rechargeDialogVisible = false
                  this.$store.commit('user/setUserInfo', {
                    balance: this.user.balance + res.data
                  });
                } else {
                  this.$yxz.msg(res.msg);
                }
              })
            } else {
              return false;
            }
          })
        } else if (this.rechargeForm.style == '01') {
          if(this.rechargeForm.money <= 0){
          	this.$wanlshop.msg('请输入充值金额');
          	return;
          }
          this.$api.post({
            url: '/zfb/recharge',
            data: {
              subAmount: this.rechargeForm.money,
              channel: this.rechargeForm.style
            }
          }).then(res => {
            if (res.code == 200) {
              document.write(res.data.payUrl)
              this.rechargeDialogVisible = false
            } else {
              this.$yxz.msg(res.msg);
            }
          })
        }

      },
      querySearch(queryString, cb) {
        var restaurants = this.restaurants;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      handleSelect(item) {
        console.log(item);
      },
      handleCurrentChange(val) {
        this.queryParams.pageNum = val
        console.log('val', this.queryParams.pageNum)
        this.loadDataList()
      },
      drawal() {
        this.open = true
        this.tixian = true
        this.detail = false
        this.chongzhi = false
        this.balanceList = []
        this.loadDataList()
      },
      rech() {
        this.open = true
        this.chongzhi = true
        this.detail = false
        this.tixian = false
        this.balanceList = []
        this.loadDataList()
      },
      access() {
        this.open = true
        this.detail = true
        this.chongzhi = false
        this.tixian = false
        this.balanceList = []
        this.loadDataList()
      },
    },
    created() {
      if (localStorage.getItem('history_input')) {
        this.restaurants = JSON.parse(localStorage.getItem('history_input'))
      }
    },
    mounted(){
      if(this.$route.query.key1 =='1'){
        this.rechargeDialogVisible = true
        this.rechargeForm.style = '01'
      }
    },
    components: {
      YShelf
    }
  }
</script>

<style lang="scss" scoped>
  .deposit-main {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-top: 30px;
    margin-bottom: 100px;
    padding-left: 80px;
  }

  .deposit-left {
    padding-right: 30px;
    width: 50%;
  }

  .deposit-right {
    width: 50%;
  }

  .l-span {
    font-size: 16px;
    color: #333;
  }

  .c-span {
    color: #333;
    font-size: 12px;
    // padding-left: 20px;
  }

  .c-text {
    color: #ff4e00;
    font-size: 20px;
  }

  .account_blance {
    margin: 6px 0 0 10px;
    color: #999;
  }

  .balance_money {
    font-weight: normal;
    color: #f90;
  }

  .pay-order-bank {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 10px 0;
    font-size: 16px;
    font-weight: 500;
  }

  .pay-bank-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 2px 0;
    width: 100%;
  }

  .pay-bank-label {
    flex: 1;
    text-align: right;
  }

  .pay-bank-value {
    flex: 4;
    padding-left: 10px;
  }

  .input-form {
    width: 50%;
  }

  .prompt {
    position: absolute;
    top: 22.5%;
    right: 16%;
    color: #999;
  }
</style>



// WEBPACK FOOTER //
// money.vue?b093fcae